import { SVGAttributes } from "react";

export function UnlockIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame">
        <path
          id="Vector"
          d="M14.1693 7.5013H7.5026V5.83464C7.5026 5.16797 7.7526 4.58464 8.2526 4.08464C9.2526 3.08464 10.8359 3.08464 11.7526 4.08464C12.0859 4.41797 12.2526 4.83464 12.4193 5.2513C12.5026 5.66797 13.0026 5.91797 13.4193 5.83464C13.8359 5.7513 14.1693 5.2513 14.0026 4.83464C13.8359 4.08464 13.4193 3.41797 12.9193 2.91797C12.1693 2.08464 11.0859 1.66797 10.0026 1.66797C7.66927 1.66797 5.83594 3.5013 5.83594 5.83464V7.5013C4.41927 7.5013 3.33594 8.58464 3.33594 10.0013V15.8346C3.33594 17.2513 4.41927 18.3346 5.83594 18.3346H14.1693C15.5859 18.3346 16.6693 17.2513 16.6693 15.8346V10.0013C16.6693 8.58464 15.5859 7.5013 14.1693 7.5013ZM10.9193 12.918L10.8359 13.0013V14.168C10.8359 14.668 10.5026 15.0013 10.0026 15.0013C9.5026 15.0013 9.16927 14.668 9.16927 14.168V13.0013C8.66927 12.5013 8.58594 11.7513 9.08594 11.2513C9.58594 10.7513 10.3359 10.668 10.8359 11.168C11.3359 11.5846 11.4193 12.418 10.9193 12.918Z"
          fill="#4B4E59"
        />
      </g>
    </svg>
  );
}
